export enum FilesUploadingStatus {
    Failed,
    PartialSuccess,
    Success
}